
import { Options, Vue } from "vue-class-component";
import LoginModalVue from "@/components/modals/login/LoginModal.vue";

@Options({
    components: {
      LoginModalVue,
    },
  })
export default class LoginPage extends Vue
{
    
}
